import { ColorPicker } from 'antd';
import { GrispiInputProps } from '..';
import GrispiInputContainer from '../GrispiInputContainer';

type GrispiColorPickerInputProps = Omit<GrispiInputProps<'COLOR_PICKER'>, 'type' | 'isNewValueAllowed'>;

const GrispiColorPickerInput = ({
    antdProps,
    containerProps,
    onChange,
    value,
    disabled,
    ...rest
}: GrispiColorPickerInputProps) => {
    return (
        <GrispiInputContainer {...containerProps}>
            <ColorPicker
                value={value}
                onChange={onChange}
                showText={true}
                disabled={disabled}
                {...antdProps}
                {...rest}
            />
        </GrispiInputContainer>
    );
};

export default GrispiColorPickerInput;
